import { get, set } from 'lodash'
import i18n from '@/config/i18n'

const formatRows = (rows) => rows.map(item => Object.values(item).join(',')).join('\n')

const formatHeaders = (rows) => (rows && rows.length) ? Object.keys(rows[0]).reduce((accumulator, item) => [...accumulator, i18n.tc(item)], []).join(',') + '\n' : []

const formatJsonableFields = (fields, item) => {
    fields.reduce((accumulator, current) => current.includes('.') && !accumulator.some(value => value === current.split('.')[0])
        ? [...accumulator, current.split('.')[0]]
        : accumulator
        , []).map(field => item[field] = (typeof item[field]) === 'string'
            ? JSON.parse(item[field])
            : item[field]
        )

    return item
}

const parseRows = (fields, items) => {
    let rows = []

    items.map((item, index) => {
        let newItem = {}

        item = formatJsonableFields(fields['columns'], item)
        
        item.iva = items[index]['tax'].name
        
        if (fields['columns'] && Object.keys(fields['columns']).length) {
            fields['columns'].map(field => {
                set(newItem, field.replace('.', '_'), get(item, field, null))
            })
        }
        rows.push({ ...newItem })
    })

    return rows
}

const exportCSV = (fields = [], items = [], fileName = 'list.csv', withHeaders = false) => {
    const fileType = 'data:text/csv;charset=UTF-8,%EF%BB%BF'
    const rows = parseRows(fields, items)
    const formattedRows = formatRows(rows)
    let link = document.createElement('a')
    let output = fileType

    if (withHeaders) {
        const formattedHeaders = formatHeaders(rows)
        output += formattedHeaders + formattedRows
    } else {
        output += formattedRows
    }

    link.setAttribute('href', output)
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
}

export {
    exportCSV
}